import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import { PageHeader } from 'app/common/presentation'
import { ConnectionsIcon } from 'app/common/presentation/icons'

import { Switch } from 'components'

import styles from './Connections.module.scss'
import { ConnectionBrowser, InstalledConnections } from './components'

const Connections = () => {
  const { t } = useTranslation('connections')
  const navigate = useNavigate()
  const location = useLocation()

  const installed = location.pathname === '/connections/installed'

  return (
    <div className={styles.connections}>
      <PageHeader icon={ConnectionsIcon} title={t('overview.headline')}>
        <Switch
          checked={!installed}
          labelChecked={t('overview.view.browse')}
          labelUnchecked={t('overview.view.installed')}
          name="connections-type"
          onChange={() => void navigate(installed ? '/connections' : '/connections/installed')}
        />
      </PageHeader>

      {installed ? <InstalledConnections /> : <ConnectionBrowser />}
    </div>
  )
}

export default Connections
